import React from 'react';
import { motion } from 'framer-motion';
import { FaReact, FaNodeJs, FaPython, FaJava, FaDatabase, FaGit, FaTools } from 'react-icons/fa';
import { SiTypescript, SiExpress, SiMongodb, SiMysql, SiJavascript, SiCplusplus, SiPostman } from 'react-icons/si';
import './TechStack.css';
import { SiOpenai } from 'react-icons/si';
import { FaRobot, FaBrain } from 'react-icons/fa';
import {  FaDocker } from 'react-icons/fa';


const TechStack = () => {
  const techCategories = [
    {
      title: 'Frontend',
      icon: <FaReact />,
      technologies: [
        { name: 'React.js', icon: <FaReact /> },
        { name: 'TypeScript', icon: <SiTypescript /> },
      ]
    },
    {
      title: 'Backend',
      icon: <FaNodeJs />,
      technologies: [
        { name: 'Node.js', icon: <FaNodeJs /> },
        { name: 'Express.js', icon: <SiExpress /> },
        { name: 'REST APIs', icon: <FaTools /> },
         { name: 'Docker', icon: <FaDocker /> },
      ]
    },

    {
      title: 'Databases',
      icon: <FaDatabase />,
      technologies: [
        { name: 'MySQL', icon: <SiMysql /> },
        { name: 'MongoDB', icon: <SiMongodb /> },
      ]
    },
    {
      title: 'Languages',
      icon: <SiJavascript />,
      technologies: [
        { name: 'C++', icon: <SiCplusplus /> },
        { name: 'Python', icon: <FaPython /> },
        { name: 'JavaScript', icon: <SiJavascript /> },
        // { name: 'Java', icon: <FaJava /> },
      ]
    },
    {
      title: 'Tools',
      icon: <FaGit />,
      technologies: [
        { name: 'Git', icon: <FaGit /> },
        { name: 'Postman', icon: <SiPostman /> },
      ]
    },

    {
  title: 'AI',
  icon: <FaRobot />,
  technologies: [
        { name: 'Gen AI', icon: <FaBrain /> },

    { name: 'AI Integration', icon: <FaRobot /> },
  ]
}
  ];

  return (
    <section id="tech-stack" className="tech-stack">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Tech Stack</h2>
          <div className="underline"></div>
        </motion.div>

        <div className="tech-grid">
          {techCategories.map((category, index) => (
            <motion.div
              key={category.title}
              className="tech-category"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="category-header">
                <div className="category-icon">{category.icon}</div>
                <h3>{category.title}</h3>
              </div>
              <div className="tech-list">
                {category.technologies.map((tech, techIndex) => (
                  <motion.div
                    key={tech.name}
                    className="tech-item"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4, delay: (index * 0.1) + (techIndex * 0.1) }}
                    viewport={{ once: true }}
                    whileHover={{ scale: 1.1 }}
                  >
                    <div className="tech-icon">{tech.icon}</div>
                    <span>{tech.name}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;